const Settings = () => (
    <div className="max-w-2xl mx-auto">
        <div className="bg-white p-8 shadow-lg rounded-xl">
            <h2 className="text-xl font-bold text-gray-800">General Settings</h2>
            <div className="mt-6 space-y-6">
                <div className="flex items-center justify-between"><p className="font-medium text-gray-800">Enable Email Notifications</p><label className="switch"><input type="checkbox" defaultChecked /><span className="slider round"></span></label></div>
                <div className="flex items-center justify-between border-t pt-6"><p className="font-medium text-gray-800">Enable SMS Marketing</p><label className="switch"><input type="checkbox" /><span className="slider round"></span></label></div>
            </div>
        </div>
        <style jsx>{`
            .switch { position: relative; display: inline-block; width: 60px; height: 34px; }
            .switch input { opacity: 0; width: 0; height: 0; }
            .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; }
            .slider:before { position: absolute; content: ""; height: 26px; width: 26px; left: 4px; bottom: 4px; background-color: white; transition: .4s; }
            input:checked + .slider { background-color: #DC2626; }
            input:checked + .slider:before { transform: translateX(26px); }
            .slider.round { border-radius: 34px; }
            .slider.round:before { border-radius: 50%; }
        `}</style>
    </div>
);
export default Settings;